const heyLibbyCapabilities = [
  'Manage your AI agents',
  'Set up outbound calling and texting campaigns',
  'Update your agent settings and scripts',
  'Launch billing and payment outreach',
  'Set your holiday hours and availability',
  'Review conversations and track performance',
]

export default heyLibbyCapabilities
